import { makeStyles } from "@material-ui/core";

export const widgetTitleStyle = makeStyles((theme) => ({
    widgetTitle: {
        color: theme.palette.primary.dark,
        fontWeight: '600',
        paddingLeft: '1.5rem',
        fontSize: 14,
        display: 'flex'
    },
    mechDashTitleStyle: {
        color: theme.palette.primary.dark,
        marginTop: '0',
        fontWeight: 500,
        fontSize: 17
    },
    header: {
        paddingTop: '1rem',
        width: '100%'
    },
    filterIcon: {
        '& path': {
            fill: theme.palette.primary.main,
            stroke: theme.palette.primary.main
        }
    },
    filters: {
        padding: '1rem',
        minWidth: '20vw',
        maxWidth: '20vw',
    },
    badge: {
        backgroundColor: '#ff5555'
    },
    exportIconWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: '0.5rem'
    },
    exportOption: {
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '& button': {
            justifyContent: 'flex-start',
            padding: '0.5rem 1rem',
            '&:hover': {
                backgroundColor: 'transparent',
            },
        },
    },
}));